import { motion } from "framer-motion";
import { VALUES, PILLARS } from "../lib/content";

const rise = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export function Mission() {
  return (
    <section id="mission" className="bg-[#0B0C10] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p {...rise} className="mono-label text-[#EF4444] mb-4">Why we exist</motion.p>
        <motion.h2 {...rise} className="font-display font-extrabold uppercase text-3xl sm:text-5xl text-white tracking-tight mb-12">Mission &amp; Vision</motion.h2>
        <div className="grid md:grid-cols-2 gap-6">
          <motion.div {...rise} className="bg-[#12141C] border border-[#212636] rounded-2xl p-8">
            <h3 className="mono-label text-slate-400 mb-4">Our Mission</h3>
            <p className="text-slate-200 leading-relaxed">No To Meth. It Leads to Death. is a community-led prevention and awareness campaign working to reduce methamphetamine-related harm and deaths — by educating communities, supporting early intervention, strengthening whānau support, amplifying lived experience, and connecting people affected by methamphetamine with pathways to professional help and recovery.</p>
          </motion.div>
          <motion.div {...rise} className="bg-[#12141C] border border-[#212636] rounded-2xl p-8">
            <h3 className="mono-label text-slate-400 mb-4">Our Vision</h3>
            <p className="text-slate-200 leading-relaxed">An Aotearoa New Zealand where fewer people start using methamphetamine, fewer people experience serious harm, fewer families are devastated by addiction, and every person affected can access timely, culturally safe support and a pathway toward recovery.</p>
          </motion.div>
        </div>
        <motion.p {...rise} className="mt-8 border-l-2 border-[#EF4444] pl-5 text-slate-300 font-grotesk italic text-lg max-w-3xl">
          We are against methamphetamine harm — not against people who use methamphetamine. That distinction shapes everything we say in public.
        </motion.p>
      </div>
    </section>
  );
}

export function Values() {
  return (
    <section id="values" className="bg-[#090A0F] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p {...rise} className="mono-label text-[#EF4444] mb-4">What guides us</motion.p>
        <motion.h2 {...rise} className="font-display font-extrabold uppercase text-3xl sm:text-5xl text-white tracking-tight mb-12">Our Values</motion.h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {VALUES.map(([name, desc], i) => (
            <motion.div key={name} {...rise} transition={{ ...rise.transition, delay: (i % 3) * 0.08 }} className="group border border-[#212636] rounded-xl p-6 hover:border-[#EF4444]/60 hover:bg-[#12141C] transition-colors">
              <h4 className="font-display font-bold text-white text-lg mb-2 group-hover:text-[#EF4444] transition-colors">{name}</h4>
              <p className="text-sm text-slate-400 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Pillars() {
  return (
    <section id="pillars" className="bg-[#0B0C10] py-24 sm:py-32 border-y border-[#212636]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p {...rise} className="mono-label text-[#EF4444] mb-4">How we work — five pillars</motion.p>
        <motion.h2 {...rise} className="font-display font-extrabold uppercase text-3xl sm:text-5xl text-white tracking-tight mb-4">Everything fits one pillar</motion.h2>
        <motion.p {...rise} className="text-slate-400 max-w-2xl mb-12">Our role today is education, prevention, community connection, navigation and advocacy — not clinical treatment. We don't say "we treat addiction." We say "we connect people with appropriate professional support."</motion.p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {PILLARS.map(([num, name, desc], i) => (
            <motion.div key={num} {...rise} transition={{ ...rise.transition, delay: i * 0.08 }} className="border-t-2 border-[#EF4444] pt-5">
              <span className="mono-label text-[#EF4444]">{num}</span>
              <h4 className="font-display font-extrabold uppercase text-white text-xl mt-2 mb-2">{name}</h4>
              <p className="text-sm text-slate-400 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
